module.exports = __webpack_public_path__ + "img/sahil-bhasin.724d2e95.jpg";